// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import SortDropdownComponent from './sortDropdown';
import { sortOptions } from '../../../../store/assortment/config';
import { getSortKey, updateSort as updateSortAction, updateAssortmentSort } from '../../../../store/assortment';
import type { SortType, SortDirection } from '../../../../helpers/compare/compare';

type StateProps = {|
  selectedSort: string,
|};

type DispatchProps = {|
  updateSort: Function,
|};

type Props = {|
  ...StateProps,
  ...DispatchProps,
|};

class SortDropdown extends Component<Props> {
  onSortChange = (selectedSortOption: string) => {
    const { updateSort } = this.props;
    const { property, direction, type } = sortOptions[selectedSortOption];

    updateSort(property, direction, type);
  }

  render() {
    const { selectedSort } = this.props;

    return (
      <SortDropdownComponent
        sortOptions={sortOptions}
        selected={selectedSort}
        onChange={this.onSortChange}
      />
    );
  }
}


const mapStateToProps = (state): StateProps => ({
  selectedSort: getSortKey(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  updateSort: (property: string, direction: SortDirection, type: SortType) => {
    dispatch(updateSortAction(property, direction, type));
    dispatch(updateAssortmentSort());
  },
});

export default connect<Props, any, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(SortDropdown);
